export default __webpack_public_path__ + "static/media/BAHL.7397f23e.png";